import RBACSwitcher from "components/common/Auth/RBACSwitcher";
import StudentSettings from "components/students/Settings";
import ParentSettings from "components/parent/Settings";
import TeacherSettings from "components/teachers/Settings";
import AdminStartupSettings from "components/adminStartup/Settings";
const Settings = () => {
  return (
    <RBACSwitcher
      admin={<AdminStartupSettings />}
      student={<StudentSettings />}
      teacher={<TeacherSettings />}
      school={<div>Set Admin ecoles</div>}
      parent={<ParentSettings />}
    />
  );
};

export default Settings;
